import styles from './UserMessage.module.css'

export type UserMessageProps = {
  children: string
}

export default function UserMessage({ children }: UserMessageProps) {
  return (
    <div className={styles.row}>
      <p className={styles.bubble}>{children}</p>
    </div>
  )
}
